export enum CompensationPayoutEntity {
    serviceConsumer = 'serviceConsumer',
    serviceGroupSetting = 'serviceGroupSetting',
    serviceOrganizationSetting = 'serviceOrganizationSetting',
    serviceProvider = 'serviceProvider',
    serviceSupervisor = 'serviceSupervisor',
}
